<template>
    <!-- Modal structure using Bootstrap data attributes -->
    <div
      class="modal fade"
      id="list-modal" 
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
    >
      <div class="modal-dialog modal-dialog-centered custom-modal-two">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header border-0 custom-modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Item List</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="onCancel"
            ></button>
          </div>
  
          <!-- Modal Body -->
          <div class="modal-body custom-modal-body">
            <div>
            	<DataTable v-if="items.length"  :tableId="'batchesTable'">
		            <thead>
		              <tr>
		                <th class="text-start">{{ $t("name") }}</th>
		                <th class="text-center">{{ $t("quantity") }}</th>
		                <th class="text-center">{{ $t("priority") }}</th>
		                <!-- <th class="text-end">{{ $t("action") }}</th> -->
		              </tr>
		            </thead>
		            <tbody>
		            	<tr v-for="item in items">
		            		<td class="text-start">{{item.item?.item_name}}</td>
		            		<td class="text-center">{{item.quantity}}</td>
		            		<td class="text-center">{{item.priority}}</td>
		            		<!-- <td></td> -->
		            	</tr>
		              
		            </tbody>
		          </DataTable>
            </div>

            <div class="modal-footer-btn">
                <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal" @click="onCancel">{{ $t('cancel') }}</button>
                <!-- <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button> -->
            </div>
          </div>  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import apiUrls from '@/urls';
  import DataTable from '@/components/common/DataTable.vue';

  export default {
  	components: {
	    DataTable,
	  },
    props: {
      items: [],
    },
    methods: {
      onSubmit() {
        this.$emit('submit'); 
      },
      onCancel() {
        this.$emit('cancel');  
      },
     
    },
  };
  </script>
  
  <style scoped>
  /* Custom Modal Styles */
    .modal-dialog {
        max-width: 50% !important;
    }

  </style>
  